import React from 'react';

import { enqueueSnackbar } from 'notistack';

import { YesNoBtnRow } from '@infoods/lifebase-ui';

import classes from './NgzUserProfileTabFlow2024.module.scss';
import { UserProfileFromValue } from './NgzUserProfileTabFlow2024.settings';

import { angularizeWithProviders } from '../../../../../shared/providers';
import { processAssignCustomersToGroup } from '../../../../../customer-group/utils/processAssignCustomersToGroup';
import { customerService } from '../../../../services/customerService';
import { getFilteredTruthyFieldsObj } from '../../../../../shared/utils/sortingAndGroupingUtil';
import { CustomerProfileForm } from '../../../../components/CustomerProfileForm/CustomerProfileForm';
import { useCustomerProfileForm } from '../../../../hooks/useCustomerProfileForm';

type NgzUserProfileTabFlow2024Props = {
  entityId: number;
  customerId: number;
};

const NgzUserProfileTabFlow2024 = ({
  entityId,
  customerId,
}: NgzUserProfileTabFlow2024Props) => {
  const { defaultValues, formMethods } = useCustomerProfileForm<UserProfileFromValue>(
    () => customerService.getCustomerInfo(customerId),
  );

  const { control, handleSubmit } = formMethods;

  const handleFormSubmit = handleSubmit(
    async ({ user, customer, inbodyInfo, additionallyInfo, customerGroup }) => {
      await processAssignCustomersToGroup(customerId, customerGroup);
      await customerService.updateCustomerProfile(customerId, {
        user,
        customer,
        inbodyInfo,
        additionallyInfo: {
          ...getFilteredTruthyFieldsObj(additionallyInfo),
          sportType: additionallyInfo.sportType,
        },
      });
      enqueueSnackbar('Customer profile has been updated successfully.', {
        variant: 'success',
        autoHideDuration: 2000,
      });
    },
  );

  return (
    <>
      <CustomerProfileForm
        mode="EDIT"
        control={control}
        entityId={entityId}
        defaultValues={defaultValues}
      />
      <YesNoBtnRow
        yesText="Save"
        className={classes.buttonRow}
        yesHandler={handleFormSubmit}
      />
    </>
  );
};

angularizeWithProviders(NgzUserProfileTabFlow2024, 'ngzUserProfileTabFlow2024', {
  entityId: '<',
  customerId: '<',
});
